import {css} from "../libs/lit.dist.js";
import './pk-stepper-step.js';

export default css`
    :host {
        display: block;
        --__done-color: var(--pk-stepper-color-done, var(--done-color, var(--bs-success)));
    }

    :host([done]) {
        --color-active: var(--__done-color);
    }

    :host([direction="reverse"]) {
        --animation-direcion: reverse;
        --animation-iteration-count: 0;
    }

    @media (max-width: 768px) {
        :host {
            //outline: 1px solid red;
        }

        :host([horizontal]),
        :host([autoHorizontal]) {
            padding-top: 1.5rem;

            &::before {
                content: var(--done-label, 'Gotowe!');
                color: var(--__done-color);
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
                transition: opacity 0.2s;
                line-height: 1;
            }

            &:host([done]) {
                &::before {
                    opacity: 1;
                    transition: opacity 0.2s 0.15s;
                }
            }
        }
    }

    :host([horizontal]),
    :host([autoHorizontal]) {
        position: relative;
        display: flex;
        width: 100%;
    }
`;
